import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DateFilter } from 'src/app/models/dateFilter';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent implements OnInit {
  dateFilter: DateFilter = new DateFilter();
  showCustomDatePicker: boolean = false;
  selectedOption: string = 'thisMonth'; // Default selected option
  @Output() dateFilterChange = new EventEmitter<DateFilter>();

  constructor(private datePipe: DatePipe){ }

  ngOnInit() {
    this.fn_setDateFilter(this.selectedOption);
  }

  fn_getSelectedDateText(): string {
    if (this.selectedOption === 'custom' && this.dateFilter.startDate && this.dateFilter.endDate) {
      return `${this.datePipe.transform(this.dateFilter.startDate, 'yyyy/MM/dd')} - ${this.datePipe.transform(this.dateFilter.endDate, 'yyyy/MM/dd')}`;
    }
    switch (this.selectedOption) {
        case 'thisMonth':
            return 'Este Mes';
        case 'lastMonth':
            return 'Mes Pasado';
        case 'thisYear':
            return 'Este Año';
        default:
            return 'Seleccionar Fecha';
    }
}

  fn_setDateFilter(option: string) {
    const today = new Date();
    let startDate: Date;
    let endDate: Date = today;

    this.selectedOption = option; // Track the selected option

    switch (option) {
        case 'thisMonth':
            startDate = new Date(today.getFullYear(), today.getMonth(), 1); // 1st of the current month
            break;

        case 'lastMonth':
            startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1); // 1st of the previous month
            endDate = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
            break;

        case 'thisYear':
            startDate = new Date(today.getFullYear(), 0, 1); // January 1st of the current year
            break;

        case 'custom':
          // For custom, do not modify startDate or endDate, but ensure dateFilter is not null
          if (this.isValidDate(this.dateFilter.startDate) && this.isValidDate(this.dateFilter.endDate)) {
              this.dateFilterChange.emit(this.dateFilter); // Emit the custom date range when confirmed
          }
          return;
  
        default:
              return;
    }

    // Set and emit the dateFilter for non-custom options
    if (this.isValidDate(startDate) && this.isValidDate(endDate)) {
      this.dateFilter.startDate = startDate;
      this.dateFilter.endDate = endDate;
      this.dateFilterChange.emit(this.dateFilter);
    }
  }

  onCustomDateChange() {
    if (this.isValidDate(this.dateFilter.startDate) && this.isValidDate(this.dateFilter.endDate)) {
        // Optionally emit changes when dates are modified directly
        this.selectedOption = 'custom';
        this.fn_getSelectedDateText()
        this.dateFilterChange.emit(this.dateFilter);
    }
  }

  toggleCustomDatePicker() {
      this.showCustomDatePicker = !this.showCustomDatePicker;
  }

  resetCustomDatePicker() {
      // Optional: Logic to reset the custom date picker state
      this.showCustomDatePicker = false;
  }

  isValidDate(date: any): boolean {
    return date instanceof Date && !isNaN(date.getTime());
  }


}
